module.exports = __webpack_public_path__ + "static/img/img2.7318aef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/puzzleImg/img2.jpg
// module id = Zop9
// module chunks = 1